export default {"src":"/_next/static/media/Checkmark.02c5ff21.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};